import React, {FC} from 'react';
import styled from 'styled-components';

import {AttachmentsEditor, AttachmentsEditorProps} from '../../common/attachments/attachmentsEditor';

/*
 * Style.
 */

const StyledAttachmentsDiv = styled.div`
  flex-shrink: 0;
  margin: 0 16px;
  padding-top: 12px;
  padding-bottom: 4px;
  border-bottom: 1px solid ${(p) => p.theme.greys.shade30};

  display: flex;
  flex-wrap: wrap;
`;

/*
 * Component.
 */

export const ComposerAttachments: FC<AttachmentsEditorProps> = (props) => {
  // We should never display inline attachments. They should be removed from the body instead.
  const displayedAttachments = props.attachments.filter((a) => !a.isInline);
  if (displayedAttachments.length === 0) {
    return null;
  }

  const newProps = {
    ...props,
    attachments: displayedAttachments,
  };

  return (
    <StyledAttachmentsDiv>
      <AttachmentsEditor {...newProps} />
    </StyledAttachmentsDiv>
  );
};
